import { addPendingAnimation, onAnimationCompletedMutator, removeActiveAnimationMutator, type MailListItemAnimation, type ActionId, } from "owa-mail-list-item-animation-store";
import { invokeAnimationCallback } from "./invokeAnimationCallback";
import { getNextActionId } from "./getNextActionId";
import { errorThatWillCauseAlert } from "owa-trace";

export function handleAnimationComplete(animation: MailListItemAnimation, rows: Element[]): void {
    const { animationAction, animationRowIds, animationCallback } = animation;
    if (animationAction == "PinInitial" || animationAction == "UnpinInitial") {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = "";
            }
        });
        enqueueNextAnimation(animation, animationAction, animationCallback);
    }
    else if (animationAction == "PinMiddle" || animationAction == "UnpinMiddle") {
        enqueueNextAnimation(animation, animationAction);
    }
    else if (animationAction == "PinFinal" ||
        animationAction == "UnpinFinal" ||
        animationAction == "AddRowFinal") {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.background = "";
                (row as HTMLDivElement).style.visibility = "";
                (row as HTMLDivElement).style.height = "";
            }
        });
    }
    else if (animationAction == "AddRowInitial") {
        rows.forEach(row => {
            if (animationRowIds?.has(row.id)) {
                (row as HTMLDivElement).style.visibility = "hidden";
                (row as HTMLDivElement).style.height = "0";
            }
        });
        enqueueNextAnimation(animation, animationAction);
    }
    else {
        invokeAnimationCallback(animation);
    }
    completeAnimationInStore(animation);
}

export function completeAnimationInStore(animation: MailListItemAnimation): void {
    switch (animation.animationAction) {
        case "PinInitial":
        case "PinMiddle":
        case "PinFinal":
        case "UnpinInitial":
        case "UnpinMiddle":
        case "UnpinFinal":
        case "AddRowInitial":
        case "AddRowFinal":
            removeActiveAnimationMutator(animation);
            break;
        default:
            onAnimationCompletedMutator(animation);
    }
}

function enqueueNextAnimation(animation: MailListItemAnimation, animationAction: ActionId, animationCallback?: () => void): void {
    if (!animation.animationRowIds) {
        errorThatWillCauseAlert("Cannot continue a mail list animation without row IDs");
        // Middle and insertion phases have already invoked their callbacks.
        animationCallback?.();
        return;
    }
    addPendingAnimation(Array.from(animation.animationRowIds), getNextActionId(animationAction), animationCallback, animation.useBatchedRowMeasurements);
}
